import { EarningsItem, MovePeriod } from '@api/api/earnings';
import { useReportedCompaniesGuidance } from '@terminal/views/theme-overview/tab-content/theme-earnings/reported-companies/useReportedCompaniesGuidance';
import { useThemeEarningsData } from '@terminal/views/theme-overview/tab-content/theme-earnings/useThemeEarningsData';
import { useThemeEarningsDrivers } from '@terminal/views/theme-overview/tab-content/theme-earnings/useThemeEarningsDrivers';
import {
  getGuidanceStat,
  getMedian,
  getSurpriseStat,
} from '@terminal/views/theme-overview/tab-content/theme-earnings/utils';
import { handlePriceData } from '@terminal/widgets/earnings/utils/tableUtils';
import { useMemo } from 'react';

export type IndustryThemeTimeframe = {
  startDate: Date;
  endDate: Date;
};

const getPeersMedian = (earnings: EarningsItem[], period: MovePeriod) =>
  getMedian(
    earnings
      .map(earning => handlePriceData(earning.price, period))
      .filter((change): change is number => change !== undefined)
  );

export const useIndustryThemeMetrics = (
  themeId: string,
  timeframe: IndustryThemeTimeframe
) => {
  // TODO: call pickClosestEarnings here

  const { earningsData, isLoading, isError, error } = useThemeEarningsData(
    themeId,
    {
      startDate: timeframe.startDate,
      endDate: timeframe.endDate,
    }
  );

  const reportedEarnings = useMemo(
    () => earningsData.filter(earning => earning.reported),
    [earningsData]
  );

  const guidanceByEarningsId = useReportedCompaniesGuidance(reportedEarnings);
  const { drivers, isFetching: isDriversFetching } =
    useThemeEarningsDrivers(reportedEarnings);

  return {
    earningsData,
    reportedCount: reportedEarnings.length,
    totalCount: earningsData.length,
    epsStat: getSurpriseStat(reportedEarnings, 'eps'),
    revenueStat: getSurpriseStat(reportedEarnings, 'revenue'),
    guidanceStat: getGuidanceStat(reportedEarnings, guidanceByEarningsId),
    medianT1: getPeersMedian(reportedEarnings, 'd1'),
    medianT2: getPeersMedian(reportedEarnings, 'd2'),
    leadingDriver: drivers[0],
    isLoading: isLoading || isDriversFetching,
    isError,
    error,
  };
};
